"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('stepper');
const Stepper = (props) => {
    const { min = 1, max, step = 1, value = min, disabled, plain, shape, size, color, bgColor, onChange, onInput, onTap, onFocus, onBlur, } = props;
    const val = value;
    const minusDisabled = val <= min || disabled;
    const plusDisabled = ((max || max === 0) && val >= max) || disabled;
    const handlePlus = () => {
        if (!val && val !== 0) {
            return;
        }
        if (plusDisabled) {
            return;
        }
        const newValue = max && val + step > max ? max : val + step;
        onTap === null || onTap === void 0 ? void 0 : onTap(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    const handleMinus = () => {
        if (!val && val !== 0) {
            return;
        }
        if (minusDisabled) {
            return;
        }
        const newValue = val - step < min ? min : val - step;
        onTap === null || onTap === void 0 ? void 0 : onTap(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    const handleInput = (e) => {
        onInput === null || onInput === void 0 ? void 0 : onInput(Number(e.target.value), e);
        onChange === null || onChange === void 0 ? void 0 : onChange(Number(e.target.value), e);
    };
    const handleFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    const handleBlur = (e) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        if (minusDisabled) {
            onInput === null || onInput === void 0 ? void 0 : onInput(min);
            onChange === null || onChange === void 0 ? void 0 : onChange(min);
        }
        if (plusDisabled) {
            onInput === null || onInput === void 0 ? void 0 : onInput(max);
            onChange === null || onChange === void 0 ? void 0 : onChange(max);
        }
    };
    return (React.createElement(one_1.View, { className: classnames_1.default(prefixCls, {
            [`${prefixCls}-${size}`]: size,
        }) },
        React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-btn`, `${prefixCls}-minus`, {
                [`${prefixCls}-btn-disabled`]: minusDisabled,
                [`${prefixCls}-btn-plain`]: plain,
                [`${prefixCls}-btn-plain-disabled`]: plain && minusDisabled,
                [`${prefixCls}-btn-circle`]: shape === 'circle',
            }), onTap: handleMinus },
            React.createElement(icon_1.default, { type: "move", size: "36px", color: "#999" })),
        React.createElement(one_1.View, { className: `${prefixCls}-input-wrapper` },
            React.createElement(one_1.Input, { className: classnames_1.default(`${prefixCls}-input`, {
                    [`${prefixCls}-input-disabled`]: disabled,
                    [`${prefixCls}-input-circle`]: shape === 'circle',
                    [`${prefixCls}-input-plain`]: plain,
                    [`${prefixCls}-binputtn-plain-disabled`]: plain && disabled,
                }), type: "number", value: String(val), onInput: handleInput, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled })),
        React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-btn`, `${prefixCls}-plus`, {
                [`${prefixCls}-btn-disabled`]: plusDisabled,
                [`${prefixCls}-btn-plain`]: plain,
                [`${prefixCls}-btn-plain-disabled`]: plain && plusDisabled,
                [`${prefixCls}-btn-circle`]: shape === 'circle',
            }), style: {
                borderColor: bgColor || color,
                backgroundColor: bgColor,
                opacity: plusDisabled && bgColor ? 0.4 : undefined,
            }, onTap: handlePlus },
            React.createElement(icon_1.default, { type: "add", size: "36px", color: color || '#333' }))));
};
exports.default = Stepper;
